/**
 * Görünürlüğe duyarlı yoklama (2026-10-20).
 *
 * Neden: sol menü, mesajlaşma, bildirim zili gibi parçalar AÇIK HER SEKMEDE 10-30 sn'de bir sunucuya
 * soruyordu. Kullanıcılar çok sekme açık bıraktığı için canlıda dakikada ~2.200 istek bunlardan
 * geliyordu ve tek süreçli backend'i doyuruyordu (donma_teshis 19.10).
 *
 * gorunurAralik(fn, ms, gizliMs):
 *   · sekme görünürken ms'de bir fn
 *   · sekme arkadayken gizliMs'de bir fn (null → hiç çalışmaz)
 *   · sekmeye dönülünce hemen bir kez fn (bekletmeden tazele)
 * Döndürdüğü fonksiyon temizlik içindir: useEffect'te `return gorunurAralik(...)`.
 */
export function gorunurAralik(fn, ms, gizliMs = null) {
  let son = 0;
  const calis = () => {
    son = Date.now();
    try { fn(); } catch { /* çağıran kendi hatasını yönetir */ }
  };
  const tik = () => {
    const gizli = typeof document !== 'undefined' && document.hidden;
    if (!gizli) {
      calis();
    } else if (gizliMs && Date.now() - son >= gizliMs - 50) {
      calis();
    }
  };
  // Gizliyken daha seyrek çalışması için tik aralığı görünür aralıktır; gizliMs kontrolü yukarıda
  const t = setInterval(tik, ms);
  const gorunurlukDegisti = () => {
    if (typeof document !== 'undefined' && !document.hidden && Date.now() - son > 2000) calis();
  };
  if (typeof document !== 'undefined') document.addEventListener('visibilitychange', gorunurlukDegisti);
  return () => {
    clearInterval(t);
    if (typeof document !== 'undefined') document.removeEventListener('visibilitychange', gorunurlukDegisti);
  };
}

export default gorunurAralik;
